const routes = [
  {
    name : 'cacheChats',
    path: 'cache-chats',
    component: () => import('@/views/chat-center/cache-chats/TheList.vue'),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
  },
  {
    name: "departmentsList",
    path: "departments",
    component: () => import("@/views/chat-center/department/TheList.vue"),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
  },
  {
    name: "departmentsNew",
    path: "departments/new",
    component: () => import("@/views/chat-center/department/TheForm.vue"),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
  },
  {
    name: "departmentsEdit",
    path: "departments/:id/edit",
    component: () => import("@/views/chat-center/department/TheForm.vue"),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "chatProvidersList",
    path: "providers",
    component: () => import("@/views/chat-center/provider/TheList.vue"),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
  },
  {
    name: "chatProvidersNew",
    path: "providers/new",
    component: () => import("@/views/chat-center/provider/TheForm.vue"),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
  },
  {
    name: "chatProvidersEdit",
    path: "providers/:id/edit",
    component: () => import("@/views/chat-center/provider/TheForm.vue"),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "botsList",
    path: "bots",
    component: () => import("@/views/chat-center/bot/TheList.vue"),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
  },
  {
    name: "botsNew",
    path: "bots/new",
    component: () => import("@/views/chat-center/bot/TheForm.vue"),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
  },
  {
    name: "botsEdit",
    path: "bots/:id/edit",
    component: () => import("@/views/chat-center/bot/TheForm.vue"),
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER"],
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "timeConditionList",
    path: "chat-center/time-conditions",
    component: () => import('@/views/chat-center/time-conditions/TheList.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    }
  },
  {
    name: "timeConditionsNew",
    path: "chat-center/time-conditions/new",
    component: () => import('@/views/chat-center/time-conditions/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    }
  },
  {
    name: "timeConditionsEdit",
    path: "chat-center/time-conditions/:id/edit",
    component: () => import('@/views/chat-center/time-conditions/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    },
    props: true
  },
  {
    name: "quickResponseTemplatesList",
    path: "quick-response-templates",
    component: () => import('@/views/chat-center/quick-response-templates/TheList.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    },
    props: true
  },
  {
    name: "quickResponseTemplatesNew",
    path: "quick-response-templates/new",
    component: () => import('@/views/chat-center/quick-response-templates/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    },
    props: true
  },
  {
    name: "quickResponseTemplatesEdit",
    path: "quick-response-templates/:id/edit",
    component: () => import('@/views/chat-center/quick-response-templates/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    },
    props: true
  },
  {
    name: "chatDispositionsList",
    path: "chat-dispositions",
    component: () => import('@/views/chat-center/chat-dispositions/TheList.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    }
  },
  {
    name: "chatDispositionsNew",
    path: "chat-dispositions/new",
    component: () => import('@/views/chat-center/chat-dispositions/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    }
  },
  {
    name: "chatDispositionsEdit",
    path: "chat-dispositions/:id/edit",
    component: () => import('@/views/chat-center/chat-dispositions/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    },
    props: true
  },
  {
    name: "chatClassificationList",
    path: "chat-classifications",
    component: () => import('@/views/chat-center/chat-classification/TheList.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    }
  },
  {
    name: "chatClassificationsNew",
    path: "chat-classifications/new",
    component: () => import('@/views/chat-center/chat-classification/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    }
  },

  {
    name: "chatClassificationsEdit",
    path: "chat-classifications/:id/edit",
    component: () => import('@/views/chat-center/chat-classification/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    },
    props: true
  },
  {
    name: "formsList",
    path: "forms",
    component: () => import('@/views/chat-center/form/TheList.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    }
  },
  {
    name: "formsNew",
    path: "forms/new",
    component: () => import('@/views/chat-center/form/CreateForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    }
  },

  {
    name: "formsEdit",
    path: "forms/:id/edit",
    component: () => import('@/views/chat-center/form/CreateForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    },
    props: true
  },

  {
    name: 'socialPagesList',
    path: "social-pages",
    component: () => import('@/views/chat-center/social-pages/TheList.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    }
  },
  {
    name: 'socialPagesCreate',
    path: "social-pages/new",
    component: () => import('@/views/chat-center/social-pages/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    },
    props: true
  },
  {
    name: 'socialPagesEdit',
    path: "social-pages/:id/edit",
    component: () => import('@/views/chat-center/social-pages/TheForm.vue'),
    meta : {
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      requiresAuth : true
    },
    props: true
  },

];

export default routes;